<template>
  <div class="enterprisemain">
    <div class="main">
      <div class="bgc"></div>
      <div class="con">
        <p class="textinfo">公司简介</p>
        <div class="one">
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          重庆隆携小额贷款有限公司是一家互联网小额贷款公司，创建于2009年6月18日，
          系经重庆市地方金融监督管理局批准成立的企业，注册资本金人民币五十亿元，经营范围为开展各项贷款、票据贴现、资产转让、以自有资金进行股权投资。公司2010年7月至今为重庆市小贷协会副会长单位；
          2013年12月至今为中国小额信贷机构联席会理事会员单位；2015年当选为中国银监会组织的中国小额贷款公司协会会员单位； <br/>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          开业以来，公司建立了现代企业的管理体系，组织机构严密，管理制度规范，造就了一支管理经验丰富、专业技术能力强、创新进取的队伍。公司秉承专业、专注，共荣、共赢的企业精神，“相携于道、功德兼隆”的企业文化，始终以市场为导向，客户为中心，通过创新贷款品种，提升贷款服务质量，为重庆和全国的中小企业、个体经营户、三农产业和人民大众提供灵活快捷的经营性和消费性信贷服务<br/>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          隆携小贷在互联网+金融的转型浪潮中，于2017年6月获得了网络贷款经营资质，同年11月正式上线了网贷产品。2019年引入了新的网络贷款业务合作平台，平台名称：德吉特平台（网址：<a
          href="https://www.jrcreditunion.com" target="_blank" class="color">https://www.jrcreditunion.com</a>；粤ICP备18100745号-1）。<br/>
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          公司将发挥锐意进取的团队精神，不断完善产品内容和风控模型，严守合规底线，确保网贷产品的持续发展，致力打造成为重庆乃至全国规范经营、服务优良、具有发展前景、具有品牌价值的小额贷款公司！
        </div>
        <div class="two">
          <p class="textinfo">公司荣誉&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>
          <div class="lunboDiv">
            <!-- assd -->
            <div class="swiper-container">
              <div class="swiper-wrapper">
                <div class="swiper-slide" v-for="(item, index) in List" :key="index">
                  <img :src="item.url" alt="公司荣誉"/>
                </div>
              </div>
              <div class="swiper-pagination"></div>
            </div>
          </div>
        </div>
        <div class="tree">
          <p class="textinfo">公司大事记</p>
          <div class="text">
            <p>○2009年06月 成立；</p>
            <p>○2010年07月 隆携小贷当选为重庆市小额贷款公司协会副会长单位，连续任职至今</p>
            <p>○2011年03月 获得重庆市“2010年度小额贷款公司十强” 和重庆市九龙坡区“2010年度先进金融企业”称号</p>
            <p>○2011年05月 与华夏银行合作接力贷（重庆唯一与华夏银行合作的小贷公司）</p>
            <p>○2011年07月 小贷资产收益权凭证在重庆金交所获首批上线交易</p>
            <p>○2012年01月 获得2011年中国小额贷款公司竞争力100强企业</p>
            <p>○2012年02月 获得2011年度重庆小额贷款公司十强企业</p>
            <p>○2012年12月 获得2012年度十佳小额贷款公司称号</p>
            <p>○2012年12月 "隆携信贷"商标被评为重庆市著名商标</p>
            <p>○2012年12月 获得2012年度十佳小额贷款公司称号</p>
            <p>○2012年12月 "隆携信贷"商标被评为重庆市著名商标</p>
            <p>○2013年01月 获得2012年中国小额贷款公司竞争力100强企业</p>
            <p>○2013年07月 获得重庆市九龙坡区2012年度金融贡献二等奖</p>
            <p>○2013年07月 获得重庆市著名商标</p>
            <p>○2013年08月 获得金茶花重庆金融总评榜2012年度十佳小贷公司称号</p>
            <p>○2014年01月 获得重庆市高新区知名商标称号</p>
            <p>○2014年01月 评为中国小额信贷机构联席会理事会员单位</p>
            <p>○2014年01月 获得2013年中国小额贷款公司竞争力100强企业</p>
            <p>○2014年01月 获得重庆十大最受信赖小额贷款公司</p>
            <p>○2015年03月 获得2014年中国小额贷款公司竞争力100强企业</p>
            <p>○2015年07月 获得重庆小额贷款十强</p>
            <p>○2016年04月 获得2015年中国小额贷款公司竞争力100强企业</p>
            <p>○2017年02月 获得2016年度最佳普惠奖</p>
            <p>○2017年04月 获得2016年中国小额贷款公司竞争力100强企业</p>
            <p>○2018年04月 获得2017年中国小微金融机构竞争力100强企业</p>
            <p>○2018年04月 获得重庆小贷协会2017年度“最佳风控奖”</p>
            <p>○2018年08月 获九龙坡区“优秀民营企业”</p>
            <p>○2020年3月，增资6.8亿，注册资本金达到人民币10亿元</p>
            <p>○2021年5月，增资10亿，注册资本金达到人民币20亿元</p>
            <p>○2021年9月，增资5亿，注册资本金达到人民币25亿元</p>
            <p>○2021年11月，增资10亿，注册资本金达到人民币35亿元</p>
            <p>○2022年5月，增资15亿，注册资本金达到人民币50亿元</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";
import "../../../node_modules/swiper/css/swiper.min.css";

export default {
  name: "enterprise",
  data() {
    return {
      List: [],
      swiper1: null,
    };
  },
  beforeMount() {
    this.List = [
      {url: require("../../assets/公司1.jpg")},
      {url: require("../../assets/公司2.jpg")},
      {url: require("../../assets/公司3.jpg")},
      {url: require("../../assets/公司4.jpg")},
      {url: require("../../assets/公司5.jpg")},
      {url: require("../../assets/公司6.jpg")},
      {url: require("../../assets/公司7.jpg")},
      {url: require("../../assets/公司8.jpg")},
      {url: require("../../assets/公司9.jpg")},
      {url: require("../../assets/公司10.jpg")},
      {url: require("../../assets/公司11.jpg")},
      {url: require("../../assets/公司12.jpg")},
      {url: require("../../assets/公司13.jpg")},
      {url: require("../../assets/公司14.jpg")},
      {url: require("../../assets/公司15.jpg")},
      {url: require("../../assets/公司16.jpg")},
      {url: require("../../assets/公司17.jpg")},
      {url: require("../../assets/公司18.jpg")},
      {url: require("../../assets/公司19.jpg")},
    ];
  },
  mounted() {
    this.initSW()
  },
  methods: {
    initSW() {
      this.swiper1 = new Swiper(".swiper-container", {
        direction: "horizontal", //默认horizontal, 水平轮播
        slidesPerView: 4, //默认1, 同时显示的slides数量,auto 代表根据轮播图的宽度排列
        speed: 2000,// 播放的速度
        autoplay: true, //自动切换
        loop: true, //循环
        autoplay: {
          delay: 2000,//1秒切换一次
          disableOnInteraction: false
        },
        spaceBetween: 20, //轮播图之间的间距
        // 分页器配置
        pagination: {
          el: ".swiper-pagination"
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.enterprisemain {
  height: 100%;

  .main {
    height: 100%;

    .bgc {
      width: 100%;
      height: 500px;
      background: url("../../assets/关于隆携.jpg") center top no-repeat;
      background-size: 100% 200%;
    }

    .con {
      height: 100%;
      margin: 0 auto;
      background-color: #f6f6f6;

      .textinfo {
        font-size: 30px;
        text-align: left;
        padding-top: 20px;
        padding-left: 50px;
      }

      .one {
        width: 80vw;
        padding: 0 50px;
        margin: 0 auto;
        text-align: left;
        font-size: 20px;

        .color {
          color: #2440b3;
          text-decoration: none;
        }
      }

      .two {
        .textinfo {
          font-size: 30px;
          text-align: left;
          padding-top: 20px;
          padding-left: 50px;
        }

        .lunboDiv {
          padding: 0 20px;

          .swiper-container {
            height: 330px;

            .swiper-wrapper {
              .swiper-slide {
                img {
                  height: 300px;
                }
              }
            }

            .swiper-pagination {
              bottom: 0;
            }
          }
        }
      }

      .tree {
        height: 100%;
        text-align: left;

        .textinfo {
          font-size: 30px;
          text-align: left;
          padding-top: 0px;
          padding-left: 50px;
        }

        .text {
          width: 80vw;
          font-size: 18px;
          padding-left: 10vw;
          padding-bottom: 20px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/Enterprise/index.vue